import { customRatio } from 'registrationReports/reportsConfig/columnTotals'
import {
  calculatePercent,
  calculateRate,
  summaryFunctions,
} from 'utils/reporting'

export default {
  id: 'county_tablet',
  name: 'County (Tablet)',
  permissionId: 'cover_sheet_tablet',
  description:
    'This report provides information from the cover sheet and data entry by collection county.',
  dataDictionaryUrl:
    'https://docs.google.com/spreadsheets/d/1icVWct65EhNnIXgnfSt_VslP8iwrZ6Rz8SztYzuNxw8/edit#gid=565021327',
  columns: [
    {
      dataKey: 'state',
      title: 'Collection State',
      type: 'string',
      resizable: true,
    },
    {
      dataKey: 'county',
      title: 'Collection County',
      type: 'string',
      resizable: true,
    },
    {
      dataKey: 'total_field_hours_cover',
      title: 'Total Field Hours',
      type: 'number',
      resizable: true,
      summaryFunction: summaryFunctions.sum,
    },
    {
      dataKey: 'forms_per_field_hour_cover',
      title: 'Forms per Field Hour',
      type: 'number',
      resizable: true,
      deriveFunction: ({ rowData }) =>
        calculateRate(
          rowData.total_forms_cover,
          rowData.total_field_hours_cover
        ),
      summaryFunction: ({ data, acc }) =>
        customRatio(data, acc, [
          'total_forms_cover',
          'total_field_hours_cover',
        ]),
    },
    {
      dataKey: 'total_shift_hours',
      title: 'Total Shift Hours',
      type: 'number',
      resizable: true,
      summaryFunction: summaryFunctions.sum,
    },
    {
      dataKey: 'total_forms_cover',
      title: 'Total Forms',
      type: 'number',
      resizable: true,
      summaryFunction: summaryFunctions.sum,
    },
    {
      dataKey: 'total_scans_qc',
      title: 'Total Forms Through QC',
      type: 'number',
      resizable: true,
      summaryFunction: summaryFunctions.sum,
    },
    {
      dataKey: 'forms_with_phones_qc',
      title: 'Forms with Phones',
      type: 'number',
      resizable: true,
      summaryFunction: summaryFunctions.sum,
    },
    {
      dataKey: 'percent_with_phones',
      title: 'Percent with Phones',
      type: 'number',
      resizable: true,
      deriveFunction: ({ rowData }) =>
        calculatePercent(rowData.forms_with_phones_qc, rowData.total_scans_qc),
      summaryFunction: ({ data, acc }) =>
        summaryFunctions.customPercent(data, acc, [
          'forms_with_phones_qc',
          'total_scans_qc',
        ]),
    },
    {
      dataKey: 'percent_scans_sms',
      title: '% of Registrations with Cell Opt-in',
      type: 'number',
      resizable: true,
      deriveFunction: ({ rowData }) =>
        calculatePercent(rowData.total_scans_sms_qc, rowData.total_scans_qc),
      summaryFunction: ({ data, acc }) =>
        summaryFunctions.customPercent(data, acc, [
          'total_scans_sms_qc',
          'total_scans_qc',
        ]),
    },
    {
      dataKey: 'percent_scans_email',
      title: '% of Registrations with Email Opt-in',
      type: 'number',
      resizable: true,
      deriveFunction: ({ rowData }) =>
        calculatePercent(rowData.total_scans_email_qc, rowData.total_scans_qc),
      summaryFunction: ({ data, acc }) =>
        summaryFunctions.customPercent(data, acc, [
          'total_scans_email_qc',
          'total_scans_qc',
        ]),
    },
    {
      dataKey: 'percent_scans_ssn',
      title: '% of Registrations with SSN',
      type: 'number',
      resizable: true,
      deriveFunction: ({ rowData }) =>
        calculatePercent(rowData.total_scans_ssn_qc, rowData.total_scans_qc),
      summaryFunction: ({ data, acc }) =>
        summaryFunctions.customPercent(data, acc, [
          'total_scans_ssn_qc',
          'total_scans_qc',
        ]),
    },
    {
      dataKey: 'percent_scans_state_id',
      title: '% Registrations with State ID',
      type: 'number',
      resizable: true,
      deriveFunction: ({ rowData }) =>
        calculatePercent(
          rowData.total_scans_state_id_qc,
          rowData.total_scans_qc
        ),
      summaryFunction: ({ data, acc }) =>
        summaryFunctions.customPercent(data, acc, [
          'total_scans_state_id_qc',
          'total_scans_qc',
        ]),
    },
  ],
}
